import { MbscModule } from '@mobiscroll/angular';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import {
  ModalModule,
  BsDropdownModule,
  CarouselModule,
  TabsModule,
  TooltipModule,
  PopoverModule,
  ProgressbarModule,
  AccordionModule,
} from "ngx-bootstrap";
import { NguCarouselModule } from "@ngu/carousel";
import { MyDatePickerModule } from "mydatepicker";
import { NgxScrollToFirstInvalidModule } from "@ismaestro/ngx-scroll-to-first-invalid";
import { MomentModule } from "ngx-moment";
import { NgxMaskModule } from "ngx-mask";
import { AgmCoreModule } from "@agm/core";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { SigninComponent } from "./auth/signin/signin.component";
import { ForgotpasswordComponent } from "./auth/forgotpassword/forgotpassword.component";
import { ResetpasswordComponent } from "./auth/resetpassword/resetpassword.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BasicinfoComponent } from "./basicinfo/basicinfo.component";
import { AppLayoutComponent } from "./layout/app-layout/app-layout.component";
import { HeaderComponent } from "./layout/header/header.component";
import { SidemenuComponent } from "./layout/sidemenu/sidemenu.component";
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { TechnicianComponent } from "./technician/technician.component";
import { EquipmentsComponent } from "./equipments/equipments.component";
import { ProcedureComponent } from "./procedure/procedure.component";
import { VacationManagementComponent } from "./vacation-management/vacation-management.component";
import { ProfilePhotosComponent } from "./profile-photos/profile-photos.component";
import { InsuranceComponent } from "./insurance/insurance.component";
import { VacationHistoryComponent } from "./vacation-history/vacation-history.component";
import { SidenavComponent } from "./layout/sidenav/sidenav.component";
import { FrontDeskComponent } from "./front-desk/front-desk.component";
import { NgXtruncateModule } from "ngx-truncate";
import { TimeSlotSettingsComponent } from "./time-slot-settings/time-slot-settings.component";
import { MedicalQuestionsComponent } from "./medical-questions/medical-questions.component";
import { NgxCurrencyModule } from "ngx-currency";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxSpinnerModule } from "ngx-spinner";
import { FileDropModule } from "ngx-file-drop";
import { ResponsiveLandingComponent } from "./responsive-landing/responsive-landing.component";
import { TechSidenavComponent } from "./layout/tech-sidenav/tech-sidenav.component";
import { ScheduleFormComponent } from "./schedule-form/schedule-form.component";
import { BottomButtonsComponent } from "./bottom-buttons/bottom-buttons.component";
import { LightboxModule } from "ngx-lightbox";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ProfileFormComponent } from "./profile-form/profile-form.component";
import { DeferLoadModule } from "@trademe/ng-defer-load";
import { PreAuthorieComponent } from "./pre-authorie/pre-authorie.component";
import { PreAutho2Component } from "./pre-autho2/pre-autho2.component";
import { AppointmentComponent } from "./appointment/appointment.component";
import { ThankyouComponent } from "./thankyou/thankyou.component";
import { PatientProfileComponent } from "./patient-profile/patient-profile.component";
import { SelectionScreenComponent } from "./selection-screen/selection-screen.component";
import { HamSidemenuComponent } from "./ham-sidemenu/ham-sidemenu.component";
import { SubpageComponent } from "./subpage/subpage.component";
import { SchedLayoutComponent } from "./schedmed-layout/sched-layout/sched-layout.component";
import { AuthHeaderComponent } from "./schedmed-layout/auth-header/auth-header.component";
import { FooterWebComponent } from "./schedmed-layout/footer-web/footer-web.component";
import { AppointmentConfirmComponent } from "./appointment-confirm/appointment-confirm.component";
import { MetroComponent } from "./metro/metro.component";
import { RegionComponent } from "./region/region.component";
import { PreAuthorizeComponent } from "./pre-authorize/pre-authorize.component";
import { ToastrModule } from "ngx-toastr";
import { HomeCalenderComponent } from "./home-calender/home-calender.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { FullCalendarModule } from "@fullcalendar/angular";
import { DashboardSidenavComponent } from "./layout/dashboard-sidenav/dashboard-sidenav.component";
import { ConfirmingDetailsComponent } from "./confirming-details/confirming-details.component";
import { WaitingListComponent } from "./waiting-list/waiting-list.component";
import { CancelNoshowComponent } from "./cancel-noshow/cancel-noshow.component";
import { CheckInPatientComponent } from "./check-in-patient/check-in-patient.component";
import { ScheduleAppointmentComponent } from "./schedule-appointment/schedule-appointment.component";
import { CreditCardComponent } from "./credit-card/credit-card.component";
import { BillingReportsComponent } from "./billing-reports/billing-reports.component";
import { HoldOrCancelComponent } from "./hold-or-cancel/hold-or-cancel.component";
import { BillingSummaryComponent } from "./billing-summary/billing-summary.component";
import { PlanSubscriptionComponent } from "./plan-subscription/plan-subscription.component";

import { ScheduleSidenavComponent } from "./layout/schedule-sidenav/schedule-sidenav.component";
import { TechnicianScheduleComponent } from "./technician-schedule/technician-schedule.component";
import { PatientInfoComponent } from "./patient-info/patient-info.component";
import { AuthorizationStatusComponent } from "./authorization-status/authorization-status.component";
import { PhysicianInformationComponent } from "./physician-information/physician-information.component";
import { PatientReviewComponent } from "./patient-review/patient-review.component";
import { CheckedInPatientComponent } from "./checked-in-patient/checked-in-patient.component";
import { NoshowPatientComponent } from "./noshow-patient/noshow-patient.component";
import { CancelledReportComponent } from "./cancelled-report/cancelled-report.component";
import { InsuranceBillingComponent } from "./insurance-billing/insurance-billing.component";
import { ReportLogComponent } from "./report-log/report-log.component";

import { NumbersOnlyDirective } from "./directive/numbers-only.directive";
import { SchedulePlanSidenavComponent } from "./layout/schedule-plan-sidenav/schedule-plan-sidenav.component";
import { PatientInfoSidenavComponent } from "./layout/patient-info-sidenav/patient-info-sidenav.component";
import { PhysicianInfoSidenavComponent } from "./layout/physician-info-sidenav/physician-info-sidenav.component";
import { ReviewSidenavComponent } from "./layout/review-sidenav/review-sidenav.component";
import { ReportSidenavComponent } from "./layout/report-sidenav/report-sidenav.component";
import { WorkHoursComponent } from "./work-hours/work-hours.component";
import { PatientSidemenuComponent } from "./patient-sidemenu/patient-sidemenu.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsComponent } from "./terms/terms.component";
import { HelpComponent } from "./help/help.component";

import { MyDateRangePickerModule } from "mydaterangepicker";
import { SelectDropDownModule } from "ngx-select-dropdown";

import { CreditCardDirective } from "./directive/credit-card-number-split";

import { TypeaheadModule } from "ngx-bootstrap";
import { HttpModule } from "@angular/http";
import { SchedmedPatientComponent } from "./schedmed-patient/schedmed-patient.component";
import { ImagingCenterPatientsComponent } from "./imaging-center-patients/imaging-center-patients.component";
import { HttpInterceptorService } from "./services/http-interceptor.service";
import { CancelAppointmentsComponent } from "./cancel-appointments/cancel-appointments.component";
import { IcCancelSidenavComponent } from "./layout/ic-cancel-sidenav/ic-cancel-sidenav.component";
import { GridWithFilterAndPaginationComponent } from "./generalComponents/grid-with-filter-and-pagination/grid-with-filter-and-pagination.component";
import { AlphaNavComponent } from "./generalComponents/alpha-nav/alpha-nav.component";
import { MerchantAgreementComponent } from "./generalComponents/merchant-agreement/merchant-agreement.component";

import { NgxPaginationModule } from "ngx-pagination";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { RatingModule } from "ng-starrating";
import { NgxPrintModule } from "ngx-print";
import { TruncateModule } from "ng2-truncate";
import {
  GoogleApiModule,
  GoogleApiService,
  GoogleAuthService,
  NgGapiClientConfig,
  NG_GAPI_CONFIG,
  GoogleApiConfig,
} from "ng-gapi";
import { environment } from "../environments/environment";
import { GoogleApiServices } from "./services/google.api.service";
const gapiClientConfig: NgGapiClientConfig = {
  client_id: environment.googleOAuthClientId,
  discoveryDocs: [
    "https://analyticsreporting.googleapis.com/$discovery/rest?version=v4",
  ],
  scope: [
    "https://www.googleapis.com/auth/calendar",
    "https://www.googleapis.com/auth/calendar.readonly",
  ].join(" "),
};
import { ScheduleReviewComponent } from "./schedule-review/schedule-review.component";
import { BillingLogComponent } from "./billing-log/billing-log.component";
import { BillingErrorsComponent } from "./billing-errors/billing-errors.component";
import { SchedmedReviewComponent } from "./schedmed-review/schedmed-review.component";
import { ImagingComponent } from "./imaging/imaging.component";
import { PatientListComponent } from "./patient-list/patient-list.component";
import { InsuranceCompaniesComponent } from "./insurance-companies/insurance-companies.component";
import { TechnologistComponent } from "./technologist/technologist.component";
import { DoctorListComponent } from "./doctor-list/doctor-list.component";
import { ManageImagingCenterComponent } from "./manage-imaging-center/manage-imaging-center.component";
import { DashboardComponent } from "./dashboard/dashboard.component";

import { SuperAdminSidenavComponent } from "./layout/super-admin-sidenav/super-admin-sidenav.component";
import { NgxUiLoaderModule, NgxUiLoaderService } from "ngx-ui-loader";
import { UtilizationComponent } from "./utilization/utilization.component";
import { EquipmentBreakdownComponent } from "./equipment-breakdown/equipment-breakdown.component";
import { CallsUsingSchedmedComponent } from "./calls-using-schedmed/calls-using-schedmed.component";
import { AnalysisAppointmentsComponent } from "./analysis-appointments/analysis-appointments.component";
import { AccessManagementComponent } from "./access-management/access-management.component";
import { IcAnalysisSidenavComponent } from "./layout/ic-analysis-sidenav/ic-analysis-sidenav.component";
import { WaitingListHistoryComponent } from "./waiting-list-history/waiting-list-history.component";
import { LocationFindComponent } from "./location-find/location-find.component";
import { MissingDetailsComponent } from "./missing-details/missing-details.component";
import { MessageCenterComponent } from "./message-center/message-center.component";
import { MessageCenterTabComponent } from "./message-center/message-center-tab.component";
import { MessageSidenavComponent } from "./message-sidenav/message-sidenav.component";
import { PatientEditComponent } from "./patient-edit/patient-edit.component";
import { RescheduledPatientComponent } from "./rescheduled-patient/rescheduled-patient.component";
import { DetailPageComponent } from "./detail-page/detail-page.component";
import { DetailSidebarComponent } from "./detail-page/detail-sidebar/detail-sidebar.component";
import { PatientNotificationsComponent } from "./patient-notifications/patient-notifications.component";
import { NotificationCardComponent } from "./patient-notifications/notification-card/notification-card.component";
import { MessageCardComponent } from "./patient-notifications/message-card/message-card.component";
import { NotificationFooterComponent } from "./patient-notifications/notification-footer/notification-footer.component";
import { NotificationLogoComponent } from "./patient-notifications/notification-logo/notification-logo.component";
import { NotificationLocationComponent } from "./patient-notifications/notification-location/notification-location.component";
import { NotificationExamTipsComponent } from "./patient-notifications/notification-exam-tips/notification-exam-tips.component";
import { AppointmentInfoComponent } from "./patient-notifications/appointment-info/appointment-info.component";
import { DownloadAppComponent } from './download-app/download-app.component';
import { DownloadAppIosComponent } from './download-app-ios/download-app-ios.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SigninComponent,
    ForgotpasswordComponent,
    ResetpasswordComponent,
    BasicinfoComponent,
    AppLayoutComponent,
    HeaderComponent,
    SidemenuComponent,
    TechnicianComponent,
    EquipmentsComponent,
    ProcedureComponent,
    VacationManagementComponent,
    ProfilePhotosComponent,
    InsuranceComponent,
    VacationHistoryComponent,
    SidenavComponent,
    FrontDeskComponent,
    TimeSlotSettingsComponent,
    MedicalQuestionsComponent,
    ResponsiveLandingComponent,
    TechSidenavComponent,
    ScheduleFormComponent,
    BottomButtonsComponent,
    ProfileFormComponent,
    PreAuthorieComponent,
    PreAutho2Component,
    AppointmentComponent,
    ThankyouComponent,
    PatientProfileComponent,
    SelectionScreenComponent,
    HamSidemenuComponent,
    SubpageComponent,
    SchedLayoutComponent,
    FooterWebComponent,
    CreditCardComponent,
    BillingReportsComponent,
    HoldOrCancelComponent,
    BillingSummaryComponent,
    PlanSubscriptionComponent,
    AuthHeaderComponent,
    DashboardSidenavComponent,
    AppointmentConfirmComponent,
    MetroComponent,
    RegionComponent,
    PreAuthorizeComponent,
    HomeCalenderComponent,
    ConfirmingDetailsComponent,
    WaitingListComponent,
    CancelNoshowComponent,
    CheckInPatientComponent,
    ScheduleAppointmentComponent,
    ScheduleSidenavComponent,
    TechnicianScheduleComponent,
    PatientInfoComponent,
    AuthorizationStatusComponent,
    PhysicianInformationComponent,
    PatientReviewComponent,
    CheckedInPatientComponent,
    NoshowPatientComponent,
    CancelledReportComponent,
    InsuranceBillingComponent,
    ReportLogComponent,
    NumbersOnlyDirective,
    SchedulePlanSidenavComponent,
    PatientInfoSidenavComponent,
    PhysicianInfoSidenavComponent,
    ReviewSidenavComponent,
    ReportSidenavComponent,
    WorkHoursComponent,
    PatientSidemenuComponent,
    PrivacyPolicyComponent,
    TermsComponent,
    HelpComponent,
    SchedmedPatientComponent,
    ImagingCenterPatientsComponent,
    CancelAppointmentsComponent,
    IcCancelSidenavComponent,
    CreditCardDirective,
    GridWithFilterAndPaginationComponent,
    AlphaNavComponent,
    MerchantAgreementComponent,
    ScheduleReviewComponent,
    BillingLogComponent,
    BillingErrorsComponent,
    SchedmedReviewComponent,
    ImagingComponent,
    PatientEditComponent,
    PatientListComponent,
    InsuranceCompaniesComponent,
    TechnologistComponent,
    DoctorListComponent,
    ManageImagingCenterComponent,
    DashboardComponent,
    SuperAdminSidenavComponent,
    UtilizationComponent,
    EquipmentBreakdownComponent,
    CallsUsingSchedmedComponent,
    AnalysisAppointmentsComponent,
    AccessManagementComponent,
    IcAnalysisSidenavComponent,
    WaitingListHistoryComponent,
    LocationFindComponent,
    MissingDetailsComponent,
    MessageCenterComponent,
    MessageCenterTabComponent,
    MessageSidenavComponent,
    RescheduledPatientComponent,
    DetailPageComponent,
    DetailSidebarComponent,
    PatientNotificationsComponent,
    NotificationCardComponent,
    MessageCardComponent,
    NotificationFooterComponent,
    NotificationLogoComponent,
    NotificationLocationComponent,
    NotificationExamTipsComponent,
    AppointmentInfoComponent,
    DownloadAppComponent,
    DownloadAppIosComponent,
  ],
  imports: [ 
    MbscModule,  
    NgxUiLoaderModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    HttpModule,
    TruncateModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NguCarouselModule,
    CarouselModule.forRoot(),
    NgxMaskModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
    }),
    MomentModule,
    MyDatePickerModule,
    BsDatepickerModule.forRoot(),
    AccordionModule.forRoot(),
    NgxScrollToFirstInvalidModule,
    TooltipModule.forRoot(),
    NgXtruncateModule,
    NgxCurrencyModule,
    ImageCropperModule,
    NgxSpinnerModule,
    FileDropModule,
    LightboxModule,
    GooglePlaceModule,
    ProgressbarModule.forRoot(),
    DeferLoadModule,
    ToastrModule.forRoot(),
    Ng2SearchPipeModule,
    FullCalendarModule,
    MyDateRangePickerModule,
    SelectDropDownModule,
    TypeaheadModule.forRoot(),
    NgxPaginationModule,
    PaginationModule.forRoot(),
    RatingModule,
    NgxPrintModule,
    GoogleApiModule.forRoot({
      provide: NG_GAPI_CONFIG,
      useValue: gapiClientConfig,
    }),
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    CurrencyPipe,
    DatePipe,
    GoogleApiServices,
    NgxUiLoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
